// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useContext } from 'react'
import { array } from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import AuthContext from './AuthContext'

// NOTE - requiredGroups is an array of string values which
// map the the various cognito user groups.
// constants/userGroups.js stores examples of these

// NOTE - when comparing the user's groups with
// the required groups, we do not AND the required groups.
// meaning if the user has at least one match, they have permission.

const AuthRoute = ({ requiredGroups, ...props }) => {
  const {
    groups,
    user,
  } = useContext(AuthContext)

  // if requiredGroups === undefined, then we don't require
  // a specific group for this page.
  const hasRequiredGroup = (
    requiredGroups !== undefined
      // checks to see if at least one of the required groups are
      // within this user's groups
      ? requiredGroups.some(d => groups.includes(d))
      : true
  )

  return (
    // if user is falsey, then the user isn't signed in.
    // or if they don't have the required group, then they're
    // trying to access a page which they don't have permission to.
    // probably via direct URL editing
    user && hasRequiredGroup
      ? <Route {...props} />
      : <Redirect to={'/'} />
  )
}

AuthRoute.propTypes = {
  requiredRole: array,
}
export default AuthRoute
